export function shouldWatchReleaseForAdoption({ event, isDockOwned, wasDockPause, takeoverKey }) {
    return Boolean(
        event?.type === 'release' &&
            !isDockOwned &&
            !wasDockPause &&
            !event.ended &&
            event.dockOnRelease &&
            takeoverKey !== event.mediaKey,
    )
}

export function shouldAdoptOwnerLifecycleEvent({ event, handoff }) {
    if (event?.type !== 'ownerLost' && event?.type !== 'ownerOffscreen') return false

    const belongsToActiveInlineHandoff =
        event.handoffToken != null &&
        event.handoffDestination === 'inline' &&
        handoff?.token === event.handoffToken &&
        handoff?.mediaKey === event.mediaKey &&
        handoff?.destination === 'inline'

    // The old inline copy can disappear while its same-post child-panel copy
    // is mounting. That owner loss belongs to the inline transition; adopting
    // it would supersede the token and start a dock iframe unnecessarily.
    return !belongsToActiveInlineHandoff
}

export function getTakeoverAfterAdoption({ takeover, candidate }) {
    const takeoverToken = takeover?.handoffToken
    const candidateToken = candidate?.handoffToken
    const hasHandoffToken = takeoverToken != null || candidateToken != null
    const isSameTransition = hasHandoffToken
        ? takeover?.mediaKey === candidate?.mediaKey &&
          takeoverToken != null &&
          takeoverToken === candidateToken
        : takeover?.mediaKey === candidate?.mediaKey

    // Navigation can synchronously report both ownerOffscreen and ownerLost.
    // Only the coordinator token identifies those events as one transition; a
    // newer token for the same video must replace the obsolete takeover.
    if (isSameTransition) return takeover

    return candidate
}

export function isDeferredDockTakeover({ takeover, handoff }) {
    return Boolean(
        takeover?.handoffToken != null &&
            handoff?.token === takeover.handoffToken &&
            handoff?.mediaKey === takeover.mediaKey &&
            handoff?.destination === 'dock' &&
            handoff?.keepSourcePlaying === true,
    )
}

export function getTakeoverAfterHandoffCancellation({
    takeover,
    cancelledMediaKey,
    cancelledHandoffToken,
}) {
    const cancellationMatchesTakeover =
        cancelledHandoffToken != null
            ? takeover?.handoffToken === cancelledHandoffToken
            : takeover?.handoffToken == null && takeover?.mediaKey === cancelledMediaKey

    if (cancellationMatchesTakeover) return null

    return takeover
}
